module.exports = __webpack_public_path__ + "static/media/dduckguck.696e8c46.png";